// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { isDemoBuild } from './siteConfig.js';
import { installDemoFetchInterceptor } from './demo/fetchInterceptor.js';
import App from './App.js';
import { AuthProvider } from './AuthContext.js';

if (isDemoBuild) {
  installDemoFetchInterceptor();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);